import { render, staticRenderFns } from "./AppAvatar.vue?vue&type=template&id=d6e13d5c&scoped=true"
import script from "./AppAvatar.vue?vue&type=script&lang=js"
export * from "./AppAvatar.vue?vue&type=script&lang=js"
import style0 from "./AppAvatar.vue?vue&type=style&index=0&id=d6e13d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e13d5c",
  null
  
)

export default component.exports